import { render, staticRenderFns } from "./IconLockBadge.vue?vue&type=template&id=7f51a422&"
import script from "./IconLockBadge.vue?vue&type=script&lang=js&"
export * from "./IconLockBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports